export default "__VITE_ASSET__DPL2hpfK__"